import { useEffect, useRef, useState } from "react";
import { endpoints } from "../../hooks/endpoints";
import { getFileUrl, getToken } from "../../hooks/utils";
import {
  invokePortalRefetch,
  invokeUserRefetch,
} from "../../store/slices/storeSlice";
import "../../styles/createQuiz.css";
import Animation from "../Animation";
import QuestionImg from "../quiz/QuestionImg";
import AddFromQuestionBank from "./AddFromQuestionBank";
import FileUploadProgressBar from "./FileUploadProgressBar";

import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { Trash2, Upload } from "lucide-react";
import { toast } from "sonner";
import { storage } from "../../firebaseConfig";
import { useAppDispatch } from "../../store/hooks";
import { pushModal } from "../../store/slices/modalsSlice";
import GeneralMessageModal from "../Modals/GeneralMessageModal";
import Spinner from "../Spinner";
import { Button } from "../ui/button";

const CreateQuiz = () => {
  const [questionsCount, setQuestionsCount] = useState([1]);
  const [questionsImages, setQuestionsImages] = useState({});
  const [successMsg, setSuccessMsg] = useState(null);
  const [publishing, setPublishing] = useState(false);
  const [fileProgress, setFileProgress] = useState(null);
  const hideCorrectAnswers = useRef();
  const randomizeQuestions = useRef();
  const mustAnswerAll = useRef();
  const [availableAnswers, setAvailableAnswers] = useState({});
  const dispatch = useAppDispatch();

  const getAnswersCount = (id) => {
    const answers = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
    const answersCount = availableAnswers[id];
    const answersOptions = [];
    for (let i = 0; i < answersCount && i < 10; i++) {
      answersOptions.push(answers[i]);
    }
    return answersOptions;
  };

  const maxMinCount = (e) => {
    const ans = document.getElementById(
      `quiz_question_ans_${e.target.id.split("_")[4]}`
    );
    ans.value = "";
    if (e.target.value > 10) {
      setAvailableAnswers((prev) => ({
        ...prev,
        [e.target.id]: 10,
      }));
      document.getElementById(e.target.id).value = 10;
    } else if (e.target.value < 2) {
      setAvailableAnswers((prev) => ({
        ...prev,
        [e.target.id]: 2,
      }));
      document.getElementById(e.target.id).value = 2;
    } else {
      setAvailableAnswers((prev) => ({
        ...prev,
        [e.target.id]: e.target.value,
      }));
    }
  };

  useEffect(() => {
    // Get all number input elements on the page
    const numberInputs = document.querySelectorAll("input[type=number]");

    // Add the event listener to each number input
    numberInputs.forEach((input) => {
      input.addEventListener("wheel", (e) => {
        e.preventDefault(); // Prevent the default behavior of scrolling
      });
    });
  }, [questionsCount]);

  const handleUploadFb = (e) => {
    if (!e.target.files[0]) {
      dispatch(
        pushModal(<GeneralMessageModal msg="يرجى اختيار ملف." btnMsg="حسنا" />)
      );
      return;
    }

    const imageRef = ref(storage, `questions-${new Date().getTime()}`);
    const uploadTask = uploadBytesResumable(imageRef, e.target.files[0]);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setFileProgress(progress.toFixed(2));
        console.log("Upload is " + progress + "% done");
      },
      (error) => {
        console.log(error);
        dispatch(
          pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />)
        );
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          console.log("cwaefsfew", downloadURL, getFileUrl(downloadURL));
          // File uploaded successfully
          const tempObject = {};
          tempObject[`quiz_question_img_url_${e.target.dataset.id}`] =
            getFileUrl(downloadURL);
          setQuestionsImages({ ...questionsImages, ...tempObject });
          document.getElementById(`qid_${e.target.dataset.id}`).value = "";
          setFileProgress(null);
        });
      }
    );
  };

  // const handleUpload = async (e) => {
  //   if (!e.target.files[0]) {
  //     dispatch(
  //       pushModal(<GeneralMessageModal msg="يرجى اختيار ملف" btnMsg="حسنا" />)
  //     );
  //     return;
  //   }

  //   try {
  //     const formData = new FormData();
  //     formData.append("file", e.target.files[0], e.target.files[0].name);

  //     const xhr = new XMLHttpRequest();

  //     // Track the progress of the upload
  //     xhr.upload.addEventListener("progress", (event) => {
  //       if (event.lengthComputable) {
  //         const percentComplete = (event.loaded / event.total) * 100;
  //         console.log(
  //           "uploadProgress",
  //           `Upload Progress: ${percentComplete.toFixed(2)}%`
  //         );
  //         if (percentComplete.toFixed(2) === "100.00") {
  //           setFileProgress(null);
  //         } else {
  //           setFileProgress(percentComplete.toFixed(2));
  //         }
  //         // You can update a progress bar or display the percentage as needed
  //       }
  //     });

  //     xhr.open("POST", endpoints.aws, true);
  //     // xhr.open("POST", endpoints.imageUpload, true);
  //     // xhr.open("POST", endpoints.drive, true);

  //     // Add the Authorization header with the token
  //     const token = getToken();
  //     xhr.setRequestHeader("Authorization", `Bearer ${token}`);

  //     xhr.onreadystatechange = function () {
  //       if (xhr.readyState === XMLHttpRequest.DONE) {
  //         if (xhr.status === 200) {
  //           try {
  //             const data = JSON.parse(xhr.responseText);

  //             if (data.success) {
  //               // File uploaded successfully
  //               const tempObject = {};
  //               tempObject[`quiz_question_img_url_${e.target.dataset.id}`] =
  //                 data.url;
  //               setQuestionsImages({ ...questionsImages, ...tempObject });
  //               document.getElementById(`qid_${e.target.dataset.id}`).value =
  //                 "";
  //               console.log(data);
  //               setFileProgress(null);
  //             } else {
  //               // File upload failed
  //               dispatch(
  //                 pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />)
  //               );
  //               setFileProgress(null);
  //             }
  //           } catch (error) {
  //             dispatch(
  //               pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />)
  //             );
  //             setFileProgress(null);
  //           }
  //         } else {
  //           // Server error
  //           dispatch(
  //             pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />)
  //           );
  //           setFileProgress(null);
  //         }
  //       }
  //     };

  //     xhr.send(formData);
  //   } catch (error) {
  //     // Network error
  //     dispatch(pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />));
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setPublishing(true);
    try {
      const formData = new FormData(e.target);
      const formDataObject = {};
      for (const [key, value] of formData.entries()) {
        formDataObject[key] = value;
      }
      formDataObject["questionsCount"] = questionsCount;
      formDataObject["hideCorrectAnswers"] = hideCorrectAnswers.current
        ? hideCorrectAnswers.current.checked
        : false;
      formDataObject["randomizeQuestions"] = randomizeQuestions.current
        ? randomizeQuestions.current.checked
        : false;
      formDataObject["mustAnswerAll"] = mustAnswerAll.current
        ? mustAnswerAll.current.checked
        : false;

      const response = await fetch(endpoints.createQuiz, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        body: JSON.stringify(formDataObject),
      });

      if (!response.ok) {
        // Handle server errors or other issues
        console.error("Error submitting the form");
        return;
      } else {
        dispatch(invokePortalRefetch());
        dispatch(invokeUserRefetch());
        setPublishing(false);
        setSuccessMsg(true);
        toast.success(
          <span className="text-green-700 text-md">
            تم إنشاء الإمتحان يمكنك الان ربطه بالحصة
          </span>
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold">
          إنشاء إمتحان جديد
        </h3>
        <form
          onSubmit={(e) => handleSubmit(e)}
          className="p-3 bg-white rounded-lg shadow-sm border space-y-4"
        >
          <div className="flex flex-col gap-2">
            <label htmlFor="title" className="block font-medium">
              عنوان الإمتحان
            </label>
            <input
              type="text"
              id="title"
              name="title"
              className="block w-full border rounded-lg px-3 py-2"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="description" className="block font-medium">
              رسالة قبل بدء الإمتحان
            </label>
            <input
              type="text"
              id="description"
              name="description"
              className="block w-full border rounded-lg px-3 py-2"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="pass_score" className="block font-medium">
              درجة النجاح
            </label>
            <input
              type="number"
              id="pass_score"
              name="pass_score"
              className="block w-full border rounded-lg px-3 py-2"
              min={0.5}
              step={0.5}
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="quiz_max_redo_count" className="block font-medium">
              عدد مرات دخول الامتحان للطالب
            </label>
            <input
              type="number"
              min={1}
              id="quiz_max_redo_count"
              name="quiz_max_redo_count"
              className="block w-full border rounded-lg px-3 py-2"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="timer" className="block font-medium">
              الوقت (بالدقائق)
            </label>
            <input
              type="number"
              id="timer"
              name="timer"
              className="block w-full border rounded-lg px-3 py-2"
              max={360}
              min={0}
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="last_trial_date" className="block font-medium">
              اخر ميعاد لدخول الإمتحان (إختياري)
            </label>
            <input
              type="datetime-local"
              id="last_trial_date"
              name="last_trial_date"
              className="block w-full border rounded-lg px-3 py-2"
            />
          </div>

          <div className="flex items-center gap-2">
            <input
              ref={hideCorrectAnswers}
              type="checkbox"
              id="hide_correct_answers"
              className="size-4"
            />
            <label htmlFor="hide_correct_answers" className="font-medium">
              إخفاء الإجابات الصحيحة
            </label>
          </div>

          <div className="flex items-center gap-2">
            <input
              ref={randomizeQuestions}
              type="checkbox"
              id="randomize_questions"
              className="size-4"
            />
            <label htmlFor="randomize_questions" className="font-medium">
              إعادة ترتيب الأسئلة لكل طالب
            </label>
          </div>

          <div className="flex items-center gap-2">
            <input
              ref={mustAnswerAll}
              type="checkbox"
              id="must_answer_all"
              className="size-4"
            />
            <label htmlFor="must_answer_all" className="font-medium">
              يجب حل جميع الأسئلة
            </label>
          </div>

          {questionsCount.map((question, index) => (
            <div
              key={question}
              className="my-6 space-y-4 pt-4 border-t border-black"
            >
              <div className="flex gap-2">
                <h5 className="mb-3 pb-2 w-fit border-b-2 border-primary font-bold">
                  سؤال رقم {index + 1}
                </h5>
                {questionsCount.length > 1 && (
                  <Button
                    type="button"
                    variant="destructive"
                    onClick={() =>
                      setQuestionsCount((prev) =>
                        prev.filter((q) => q !== question)
                      )
                    }
                  >
                    <Trash2 className="size-4" />
                  </Button>
                )}
              </div>

              <AddFromQuestionBank
                questionNum={question}
                setQuestionsImages={setQuestionsImages}
                questionsImages={questionsImages}
                setAvailableAnswers={setAvailableAnswers}
                availableAnswers={availableAnswers}
                prefix={"quiz_"}
              />

              <input
                id={`qid_${question}`}
                type="hidden"
                name={`qid_${question}`}
              />

              {fileProgress &&
                fileProgress < 100 &&
                fileProgress >= 0 &&
                index + 1 === questionsCount.length && (
                  <FileUploadProgressBar fileProgress={fileProgress} />
                )}

              {!questionsImages[`quiz_question_img_url_${question}`] && (
                <Button
                  type="button"
                  variant="outline"
                  className="hover:bg-purple-200 w-full h-fit py-5 rounded-lg bg-purple-100 border-2 border-dashed border-purple-500 flex flex-col gap-2 items-center justify-center"
                  onClick={() =>
                    document
                      .getElementById(`quiz_question_img_input_${question}`)
                      ?.click()
                  }
                >
                  <Upload className="size-10" />
                  <p className="no-underline">إفع صورة السؤال</p>
                </Button>
              )}

              <input
                id={`quiz_question_img_input_${question}`}
                onChange={(e) => handleUploadFb(e)}
                data-id={question}
                className="w-full border rounded-lg px-3 py-2"
                type="file"
                hidden
                name={`quiz_question_img_input_${question}`}
              />

              {questionsImages[`quiz_question_img_url_${question}`] && (
                <QuestionImg
                  id={`uploaded-image-${question}`}
                  src={questionsImages[`quiz_question_img_url_${question}`]}
                  alt=""
                  className="m-auto mb-2 rounded-lg"
                  border="2px solid #ddd"
                  onImgDelete={() => {
                    delete questionsImages[`quiz_question_img_url_${question}`];
                    setQuestionsImages({ ...questionsImages });
                  }}
                />
              )}

              <input
                id={`quiz_question_img_url_${question}`}
                value={questionsImages[`quiz_question_img_url_${question}`]}
                type="hidden"
                name={`quiz_question_img_url_${question}`}
                required
              />

              <div className="mb-3">
                <label
                  htmlFor={`quiz_question_textarea_${question}`}
                  className="block mb-1 font-medium"
                >
                  محتوى السؤال (اختياري)
                </label>
                <textarea
                  id={`quiz_question_textarea_${question}`}
                  name={`quiz_question_textarea_${question}`}
                  rows={3}
                  className="block w-full border rounded-lg px-3 py-2"
                ></textarea>
              </div>

              <div className="mb-3">
                <label
                  htmlFor={`quiz_question_ans_count_${question}`}
                  className="block mb-1 font-medium"
                >
                  عدد الإجابات
                </label>
                <input
                  type="number"
                  id={`quiz_question_ans_count_${question}`}
                  name={`quiz_question_ans_count_${question}`}
                  className="block w-full border rounded-lg px-3 py-2"
                  max={10}
                  min={2}
                  required
                  onChange={(e) => maxMinCount(e)}
                />
              </div>

              <div className="mb-3">
                <label
                  htmlFor={`quiz_question_ans_${question}`}
                  className="block mb-1 font-medium"
                >
                  الإجابة الصحيحة
                </label>
                <select
                  id={`quiz_question_ans_${question}`}
                  name={`quiz_question_ans_${question}`}
                  className="block w-full border rounded-lg px-3 py-2"
                  required
                >
                  <option value="">الإجابة الصحيحة</option>
                  {getAnswersCount(`quiz_question_ans_count_${question}`).map(
                    (ans) => (
                      <option key={ans} value={ans}>
                        {ans}
                      </option>
                    )
                  )}
                </select>
              </div>

              <div className="mb-3">
                <label
                  htmlFor={`quiz_question_weight_${question}`}
                  className="block mb-1 font-medium"
                >
                  الدرجة
                </label>
                <input
                  type="number"
                  min={0.5}
                  step={0.5}
                  id={`quiz_question_weight_${question}`}
                  name={`quiz_question_weight_${question}`}
                  className="block w-full border rounded-lg px-3 py-2"
                  required
                />
              </div>
            </div>
          ))}

          <div className="mb-3">
            <Button
              type="button"
              disabled={fileProgress && fileProgress < 100 && fileProgress >= 0}
              onClick={() =>
                setQuestionsCount((prev) => [
                  ...prev,
                  prev[prev.length - 1] + 1,
                ])
              }
              className="rounded-lg font-bold px-4 py-2 bg-green-600 hover:bg-green-700 text-white"
            >
              +
            </Button>
          </div>

          <Button
            type="submit"
            className="w-full rounded-lg"
            disabled={
              (typeof fileProgress === "number" && !isNaN(fileProgress)) ||
              publishing
            }
          >
            {publishing ? <Spinner variant="button" /> : "نشر"}
          </Button>
        </form>
      </div>
    </Animation>
  );
};

export default CreateQuiz;
